import {FailedUploadItem} from './failedUploadItem.modal';

export class FailedUploadData {
  pageCount: number;
  dataList: FailedUploadItem[] = [];
}
